/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DailyNavDeliveryCompDelta } from './DailyNavDeliveryCompDelta';
import type { DailyNavDeliveryReportedPrice } from './DailyNavDeliveryReportedPrice';
import type { DailyNavDeliveryReview } from './DailyNavDeliveryReview';
import type { DailyNavDeliverySecondaryDelta } from './DailyNavDeliverySecondaryDelta';
/**
 * One entry per monitored company, ordered by company name. Not paginated: a NAV day is read whole, and a truncated grid would silently under-report the portfolio.
 */
export type DailyNavDeliveryRecord = {
  /**
   * Scalar's identifier for the portfolio company. Stable.
   */
  company_id: number;
  /**
   * The company's display name.
   */
  company_name: string;
  /**
   * The company's identifier in the firm's own upstream system, as recorded on the company record -- the key to join this row to the firm's books rather than to Scalar's. Null when none is recorded.
   */
  external_id: string | null;
  /**
   * The NAV date, formatted as YYYY-MM-DD
   */
  date: string;
  /**
   * The row's review outcome. `reviewed`: the checklist is complete. `review_status`: nothing breached and nothing needed doing. `review_price`: a threshold was breached and the review has not started. `in_progress`: partially answered. `needs_new_price`: a price was deferred onto this day and has not landed. On a finalized day every row has cleared the gate, so the blocking statuses should not appear.
   */
  status: DailyNavDeliveryRecord.status;
  /**
   * The market-data profile this company's private-market prices came from. Null when unlinked, which is why its secondary block would report `not_linked`.
   */
  alexandria_id: string | null;
  /**
   * The company settings version this row was evaluated under. Null when the version has since been deleted, in which case the row cannot name its own rules.
   */
  company_config_version_id: number | null;
  review: DailyNavDeliveryReview;
  reported_price: DailyNavDeliveryReportedPrice;
  comp_delta: DailyNavDeliveryCompDelta;
  secondary_delta: DailyNavDeliverySecondaryDelta;
  /**
   * True when any window or the change-from-mark comparison breached its threshold, across both sources. A convenience over the individual `exceeded` flags, which remain authoritative per comparison.
   */
  any_threshold_exceeded: boolean;
};
export namespace DailyNavDeliveryRecord {
  /**
   * The row's review outcome. `reviewed`: the checklist is complete. `review_status`: nothing breached and nothing needed doing. `review_price`: a threshold was breached and the review has not started. `in_progress`: partially answered. `needs_new_price`: a price was deferred onto this day and has not landed. On a finalized day every row has cleared the gate, so the blocking statuses should not appear.
   */
  export enum status {
    REVIEWED = 'reviewed',
    IN_PROGRESS = 'in_progress',
    REVIEW_PRICE = 'review_price',
    REVIEW_STATUS = 'review_status',
    NEEDS_NEW_PRICE = 'needs_new_price',
  }
}

